var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.setIntervalMining = void 0;
  async function setIntervalMining(client, {
    interval
  }) {
    const interval_ = (() => {
      if (client.mode === "hardhat") return interval * 1000;
      return interval;
    })();
    await client.request({
      method: "evm_setIntervalMining",
      params: [interval_]
    });
  }
  exports.setIntervalMining = setIntervalMining;
  //# sourceMappingURL=setIntervalMining.js.map
  return exports;
}